/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Getstarted1Inputs */

const en_common_getstarted1 = /** @type {(inputs: Common_Getstarted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started`)
};

/**
* | output |
* | --- |
* | "Get started" |
*
* @param {Common_Getstarted1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_getstarted1 = /** @type {((inputs?: Common_Getstarted1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Getstarted1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_getstarted1(inputs)
});
export { common_getstarted1 as "common_getStarted" }